<template>
	<app-content class="h-panel">
		<Loading text="数据加载中..." :loading="loading"></Loading>
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="report">{{report.name}}</template>&nbsp;</span>
			<Button class="float-right" @click="$router.back()">返回</Button>
		</div>
		<div class="margin-top margin-left margin-right">
			<account-date-choose v-model="accountDate"/>
			<Button class="h-btn float-right margin-left" :loading="resetLoading" v-if="User.role!=='View'" @click="resetTemplate">恢复默认报表</Button>
			<Button class="h-btn float-right margin-left" color="green" :loading="exportLoading" @click="exportExcel" :disabled="!accountDate">导出Excel</Button>
			<Button class="h-btn float-right margin-left" color="primary" v-if="isCashFlowReport" :loading="openingLoading" @click="openOpeningModal" :disabled="!accountDate">期初</Button>
			<router-link tag="button" class="h-btn float-right" v-if="User.role!=='View'" :to="{name:'TemplateForm',params:{templateId:reportId}}">编辑数据项</router-link>
		</div>
		<div ref="reportPanelBody" class="h-panel-body">
				<Table class="small-td" :datas="templateItems" :height="reportTableHeight" selectRow border v-if="report.type==0">
					<TableItem title="项目">
						<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
					</TableItem>
					<TableItem title="行次">
						<template slot-scope="{data}">
							{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
						</template>
					</TableItem>
						<TableItem title="本月金额" align="right">
							<template slot-scope="{data}">
								<span 
									v-if="isClickable(data, 'currentPeriod')" 
									class="clickable-amount" 
									@click="showVouchers(data, reportData[data.id]?reportData[data.id].currentPeriodAmount:0)"
								>
									{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
								</span>
								<span v-else>
									{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
								</span>
							</template>
						</TableItem>
						<TableItem title="本年累计金额" align="right">
							<template slot-scope="{data}">
								<span 
									v-if="isClickable(data)" 
									class="clickable-amount" 
									@click="showVouchers(data, reportData[data.id]?reportData[data.id].currentYearAmount:0)"
								>
									{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
								</span>
								<span v-else>
									{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
								</span>
							</template>
						</TableItem>
					</Table>
				<Table class="small-td" :datas="templateItems" :height="reportTableHeight" selectRow border v-else-if="isCashFlowReport">
					<TableItem title="项目">
						<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
					</TableItem>
					<TableItem title="行次">
						<template slot-scope="{data}">
							{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
						</template>
					</TableItem>
					<TableItem title="本月金额" align="right">
						<template slot-scope="{data}">
							<span 
								v-if="isClickable(data, 'currentPeriod')" 
								class="clickable-amount" 
								@click="showVouchers(data, reportData[data.id]?reportData[data.id].currentPeriodAmount:0)"
							>
								{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
							</span>
							<span v-else>
								{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
							</span>
						</template>
					</TableItem>
					<TableItem title="本年累计金额" align="right">
						<template slot-scope="{data}">
							<span 
								v-if="isClickable(data, 'currentYear')" 
								class="clickable-amount" 
								@click="showVouchers(data, reportData[data.id]?reportData[data.id].currentYearAmount:0)"
							>
								{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
							</span>
							<span v-else>
								{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
							</span>
						</template>
					</TableItem>
					<TableItem title="上年同期累计" align="right">
						<template slot-scope="{data}">
							<span>
								{{reportData[data.id]?reportData[data.id].lastYearAmount:''|numFormat}}
							</span>
						</template>
					</TableItem>
				</Table>
				<Table :datas="templateItemsRender" :height="reportTableHeight" selectRow border v-else-if="report.type == 1">
					<TableItem title="资产">
						<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
					</TableItem>
					<TableItem title="行次">
						<template slot-scope="{data}">
							{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
						</template>
					</TableItem>
					<TableItem title="期末余额" align="right">
						<template slot-scope="{data}">
							{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
						</template>
					</TableItem>
					<TableItem title="年初余额" align="right">
						<template slot-scope="{data}">
							{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
						</template>
					</TableItem>
					<TableItem title="负债和所有者权益">
						<div slot-scope="{data}" :class="{'font-bold':data.fs_isBolder}" :style="{paddingLeft:((data.fs_level-1)*15)+'px'}">{{data.fs_title}}</div>
					</TableItem>
					<TableItem title="行次">
						<template slot-scope="{data}">
							{{data.fs_isClassified ? '':data.fs_lineNum>-1?data.fs_lineNum:''}}
						</template>
					</TableItem>
					<TableItem title="期末余额" align="right">
						<template slot-scope="{data}">
							{{reportData[data.fs_id]?reportData[data.fs_id].currentPeriodAmount:''|numFormat}}
						</template>
					</TableItem>
					<TableItem title="年初余额" align="right">
						<template slot-scope="{data}">
							{{reportData[data.fs_id]?reportData[data.fs_id].currentYearAmount:''|numFormat}}
						</template>
					</TableItem>
				</Table>
		</div>
		<!-- 凭证明细弹窗 -->
		<Modal v-model="voucherModal.visible" title="关联凭证明细" width="90%">
			<Loading :loading="voucherModal.loading" text="加载中..."></Loading>
			<div v-if="!voucherModal.loading">
				<p class="modal-info">项目：{{voucherModal.itemTitle}} | 金额：{{voucherModal.amount | numFormat}}</p>
				<Table :datas="voucherModal.vouchers" border>
					<TableItem title="日期" prop="voucherDate" width="120"></TableItem>
					<TableItem title="凭证字号" width="120">
						<template slot-scope="{data}">
							<router-link v-if="data.voucherId" :to="{name:'VoucherForm',params:{voucherId:data.voucherId}}" target="_blank">
								{{data.word}}-{{data.code}}
							</router-link>
						</template>
					</TableItem>
					<TableItem title="科目" prop="subjectName"></TableItem>
					<TableItem title="摘要" prop="summary"></TableItem>
					<TableItem title="借方" align="right">
						<template slot-scope="{data}">
							{{data.debitAmount|numFormat}}
						</template>
					</TableItem>
					<TableItem title="贷方" align="right">
						<template slot-scope="{data}">
							{{data.creditAmount|numFormat}}
						</template>
					</TableItem>
				</Table>
				<p v-if="!voucherModal.vouchers || voucherModal.vouchers.length === 0" class="no-data">暂无凭证数据</p>
			</div>
			<div slot="footer">
				<Button @click="voucherModal.visible = false">关闭</Button>
			</div>
		</Modal>
		<Modal v-model="openingModalVisible" hasCloseIcon :width="960">
			<div slot="header">现金流量表初始数据</div>
			<Loading text="加载中..." :loading="openingLoading"></Loading>
			<div class="opening-range">{{openingRangeLabel}}</div>
			<div class="opening-tip">说明：这里录入的是当前报表月份之前的累计金额，只影响现金流量表，不改账套期初或凭证。</div>
			<Table class="small-td opening-table" :datas="openingPreviewItems" border>
				<TableItem title="项目">
					<template slot-scope="{data}">
						<div :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
					</template>
				</TableItem>
				<TableItem title="行次" :width="90" align="center">
					<template slot-scope="{data}">
						{{data.isClassified ? '' : (data.lineNum > -1 ? data.lineNum : '')}}
					</template>
				</TableItem>
				<TableItem :title="openingRangeLabel || '累计金额'" align="right" :width="220">
					<template slot-scope="{data}">
						<NumberInput
							v-if="isEditableOpeningItem(data)"
							:value="openingForm.amounts[data.id]"
							:precision="2"
							@input="setOpeningAmount(data.id, $event)"
						/>
						<span v-else>{{formatOpeningAmount(getOpeningComputedAmount(data))}}</span>
					</template>
				</TableItem>
			</Table>
			<div class="opening-footer">
				<div class="opening-balance">
					<span class="label">本月期初现金余额</span>
					<NumberInput v-model="openingForm.openingCashBalance" :precision="2"/>
				</div>
				<div class="opening-remark">
					<span class="label">备注</span>
					<textarea v-model="openingForm.remark" class="opening-textarea" rows="2" placeholder="可选"></textarea>
				</div>
			</div>
			<div class="text-center margin-top">
				<Button type="error" @click="clearOpening" :loading="openingSaving">清空</Button>
				<Button color="green" @click="saveOpening" :loading="openingSaving">保存</Button>
				<Button @click="openingModalVisible = false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: "ReportView.vue",
		props: {
			reportId: [Number, String]
		},
		data() {
			return {
				report: {},
				reportData: {},
				accountDate: null,
				loading: false,
				exportLoading: false,
				resetLoading: false,
				reportTableHeight: 520,
				openingModalVisible: false,
				openingLoading: false,
				openingSaving: false,
				openingRangeLabel: '',
				openingForm: {
					openingCashBalance: null,
					remark: '',
					amounts: {}
				},
				voucherModal: {
					visible: false,
					loading: false,
					vouchers: [],
					itemTitle: '',
					amount: 0
				}
			}
		},
		computed: {
			...mapState(['User']),
			templateItems() {
				return this.report ? this.report.items : [];
			},
			isCashFlowReport() {
				return this.report && (this.report.templateKey === 'cash-flow-statement' || this.report.type === 2 || this.report.type === 3);
			},
			openingPreviewItems() {
				return this.templateItems.filter(item => !this.isCashBalanceItem(item));
			},
			templateItemsRender() {
				if (this.report.type === 1) {
					//所有资产
					let zc = this.templateItems.filter(val => val.type === 0);
					let sq = this.templateItems.filter(val => val.type !== 0);
					sq.forEach((val, index) => {
						let changeObj = {
							fs_id: val.id,
							fs_lineNum: val.lineNum,
							fs_isBolder: val.isBolder,
							fs_level: val.level,
							fs_isClassified: val.isClassified,
							fs_title: val.title
						};
						if (zc[index]) {
							Object.assign(zc[index], changeObj);
						}
					});
					return zc;
				}
				return [];
			}
		},
		watch: {
			accountDate() {
				this.loadReportData();
			},
			reportId() {
				this.loadReport();
			},
			report() {
				this.$nextTick(this.updateReportTableHeight);
			}
		},
		mounted() {
			this.updateReportTableHeight();
			window.addEventListener('resize', this.updateReportTableHeight);
			// 初始化账期为当前账套的当前账期
			if (this.$store.state.orgDatas && this.$store.state.orgDatas.length > 0) {
				const currentOrg = this.$store.state.orgDatas.find(org => org.id === this.$store.state.currentOrgId) || this.$store.state.orgDatas[0];
				this.accountDate = currentOrg.currentAccountDate;
			}
			// 加载报表
			this.loadReport();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateReportTableHeight);
		},
		methods: {
			updateReportTableHeight() {
				this.$nextTick(() => {
					const panelBody = this.$refs.reportPanelBody;
					if (!panelBody || !panelBody.getBoundingClientRect) {
						this.reportTableHeight = 520;
						return;
					}
					const rect = panelBody.getBoundingClientRect();
					const scrollContainer = panelBody.closest('.app-frame-content')
						|| panelBody.closest('.h-layout-content');
					const containerRect = scrollContainer && scrollContainer.getBoundingClientRect
						? scrollContainer.getBoundingClientRect()
						: { bottom: window.innerHeight };
					const footerReserve = 40;
					this.reportTableHeight = Math.max(containerRect.bottom - rect.top - footerReserve, 240);
				});
			},
			syncReportTitle(title) {
				const reportTitle = title || '报表数据';
				window.document.title = 'AI模范 - ' + reportTitle;
				this.$root.$emit('sys-tabs:update-title', {
					name: this.$route.name,
					params: this.$route.params,
					query: this.$route.query,
					title: reportTitle
				});
			},
			loadReport() {
				return Api.report.template.load(this.reportId).then(({data}) => {
					this.report = data;
					this.syncReportTitle(data && data.name);
					this.$nextTick(this.loadReportData);
				});
			},
			loadReportData() {
				if (!this.accountDate) return;
				this.loading = true;
				Api.report.view(this.reportId, {accountDate: this.accountDate}).then(({data}) => {
					this.reportData = data;
				}).finally(() => this.loading = false);
			},
			exportExcel() {
				if (!this.accountDate) {
					this.$Message.error('请选择会计日期');
					return;
				}

				this.exportLoading = true;
				const params = {
					accountDate: this.accountDate,
					reportName: this.report.name
				};

				Api.report.export.template(this.reportId, params).then(() => {
					this.$Message.success(this.report.name + '导出成功');
				}).catch((error) => {
					console.error('导出失败:', error);
					this.$Message.error('导出失败，请重试');
				}).finally(() => {
					this.exportLoading = false;
				});
			},
			resetTemplate() {
				this.$Confirm('确定将当前报表恢复为默认模板？此操作会覆盖当前自定义配置。', '确认恢复').then(() => {
					this.resetLoading = true;
					Api.report.template.reset(this.reportId).then(() => {
						this.$Message.success('恢复成功');
						return this.loadReport();
					}).finally(() => {
						this.resetLoading = false;
					});
				});
			},
			isClickable(data, columnType) {
				if (!this.isCashFlowReport) {
					return false;
				}
				if (columnType !== 'currentPeriod') {
					return false;
				}
				// 非合计项目(sources=0)且有公式的项目可点击
				return data.sources === 0 && data.formulas && data.formulas.length > 0;
			},
			showVouchers(data, amount) {
				// 如果金额为0或空，不查询
				if (!amount || amount === 0) {
					this.$Message.info('该项目暂无发生额');
					return;
				}
				
				this.voucherModal.itemTitle = data.title;
				this.voucherModal.amount = amount;
				this.voucherModal.visible = true;
				this.voucherModal.loading = true;
				this.voucherModal.vouchers = [];
				
				this.$api.report.getItemVouchers({
					itemId: data.id,
					templateId: this.reportId,
					accountDate: this.accountDate
				}).then(({data: vouchers}) => {
					this.voucherModal.vouchers = vouchers || [];
				}).catch((error) => {
					console.error('获取凭证失败:', error);
					this.$Message.error('获取凭证失败');
				}).finally(() => {
					this.voucherModal.loading = false;
				});
			},
			openOpeningModal() {
				if (!this.accountDate || !this.isCashFlowReport) {
					return;
				}
				this.openingModalVisible = true;
				this.loadOpeningConfig();
			},
			loadOpeningConfig() {
				this.openingLoading = true;
				Api.report.cashFlowOpening({accountDate: this.accountDate}).then(({data}) => {
					const amountMap = {};
					(data.items || []).forEach(item => {
						const matched = this.findOpeningTemplateItem(item);
						if (matched && this.isEditableOpeningItem(matched)) {
							amountMap[matched.id] = item.amount;
						}
					});
					this.openingForm = {
						openingCashBalance: data.openingCashBalance,
						remark: data.remark || '',
						amounts: amountMap
					};
					this.openingRangeLabel = data.rangeLabel || '';
				}).finally(() => {
					this.openingLoading = false;
				});
			},
			saveOpening() {
				if (!this.accountDate) {
					this.$Message.error('请选择会计日期');
					return;
				}
				const items = this.openingPreviewItems
					.filter(item => !this.isSectionItem(item))
					.map(item => ({
						templateItemId: item.id,
						lineNum: item.lineNum,
						itemTitle: item.title,
						amount: this.getOpeningComputedAmount(item)
					}))
					.filter(item => item.amount !== null && item.amount !== undefined && item.amount !== '');
				this.openingSaving = true;
				Api.report.saveCashFlowOpening({
					accountDate: this.accountDate,
					openingCashBalance: this.openingForm.openingCashBalance,
					remark: this.openingForm.remark,
					items
				}).then(() => {
					this.$Message.success('现金流量表期初已保存');
					this.openingModalVisible = false;
					this.loadReportData();
				}).finally(() => {
					this.openingSaving = false;
				});
			},
			clearOpening() {
				if (!this.accountDate) {
					return;
				}
				this.$Confirm('确认清空当前月份的现金流量表期初设置？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					this.openingSaving = true;
					return Api.report.deleteCashFlowOpening(this.accountDate).then(() => {
						this.$Message.success('已清空');
						this.openingModalVisible = false;
						this.loadReportData();
					}).finally(() => {
						this.openingSaving = false;
					});
				}).catch(() => {});
			},
			isCashBalanceItem(item) {
				if (!item || !item.title) {
					return false;
				}
				return item.title.indexOf('期初现金余额') > -1 || item.title.indexOf('期末现金余额') > -1;
			},
			isSectionItem(item) {
				return item && (!item.formulas || item.formulas.length === 0) && item.sources === 0;
			},
			isEditableOpeningItem(item) {
				return item && item.sources === 0 && !item.isClassified && !this.isCashBalanceItem(item) && !this.isSectionItem(item);
			},
			setOpeningAmount(itemId, value) {
				this.$set(this.openingForm.amounts, itemId, value);
			},
			getOpeningComputedAmount(item, visited = {}) {
				if (!item) {
					return null;
				}
				if (visited[item.id]) {
					return 0;
				}
				if (this.isEditableOpeningItem(item)) {
					const value = this.openingForm.amounts[item.id];
					return value === '' || value === null || value === undefined ? null : Number(value);
				}
				if (!item.formulas || item.formulas.length === 0) {
					return null;
				}
				visited[item.id] = true;
				let total = null;
				item.formulas.forEach(formula => {
					const dependency = this.templateItems.find(candidate => String(candidate.id) === String(formula.fromTag));
					if (!dependency) {
						return;
					}
					const amount = Number(this.getOpeningComputedAmount(dependency, visited) || 0);
					if (total === null) {
						total = amount;
						return;
					}
					total += formula.calculation === '-' ? -amount : amount;
				});
				delete visited[item.id];
				return total;
			},
			formatOpeningAmount(value) {
				if (value === null || value === undefined || value === '') {
					return '';
				}
				return this.$options.filters.numFormat(value);
			},
			findOpeningTemplateItem(savedItem) {
				if (!savedItem) {
					return null;
				}
				return this.templateItems.find(item =>
					String(item.id) === String(savedItem.templateItemId)
					|| (savedItem.lineNum != null && item.lineNum === savedItem.lineNum)
					|| (savedItem.itemTitle && item.title === savedItem.itemTitle)
				);
			}
		}
	}
</script>

<style scoped>
	div.font-bold {
		font-size: 14px;
	}
	.clickable-amount {
		color: #2d8cf0 !important;
		cursor: pointer !important;
		text-decoration: underline !important;
		font-weight: bold;
	}
	.clickable-amount:hover {
		color: #5cadff !important;
	}
	.modal-info {
		margin-bottom: 10px;
		font-weight: bold;
		font-size: 14px;
	}
	.no-data {
		text-align: center;
		padding: 20px;
		color: #999;
	}
	.opening-range {
		margin-bottom: 8px;
		font-size: 14px;
		font-weight: 600;
	}
	.opening-tip {
		margin-bottom: 12px;
		color: #666;
	}
	.opening-table {
		max-height: 520px;
		overflow-y: auto;
	}
	.opening-footer {
		margin-top: 16px;
	}
	.opening-balance,
	.opening-remark {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
	}
	.opening-footer .label {
		width: 140px;
		color: #555;
	}
	.opening-textarea {
		width: 100%;
		min-height: 60px;
		padding: 8px 10px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		resize: vertical;
	}
</style>
